import { render, staticRenderFns } from "./BtnExcluirItem.vue?vue&type=template&id=441f41dd&"
import script from "./BtnExcluirItem.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports